<template>
  <div>
    <wg-modal v-if="deleteLinkDialog" @closeModal="deleteLinkDialog = false">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div
          class="com-anm22-app-text-xl"
        >{{ $anm22.strLang(lang, 'Delete link?', 'Cancellare link?') }}</div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="deleteLink(currentIndex)"
          />
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="deleteLinkDialog = false"
          />
        </div>
      </div>
    </wg-modal>
    <div class="links">
      <div class="wg-row icons">
        <div
          v-for="(link,i) in links"
          :key="'link-'+i"
          style="position:relative;"
          :title="link.label == '' ? link.link : link.label"
        >
          <a :href="link.link" target="_blank">
            <div :class="['icon-div',isModal ? 'small' : '']">
              <img class="com-anm22-app-img-fixed-height-l links-img" :src="imgByLink(link)" />
            </div>
          </a>
          <img
            class="com-anm22-app-img-fixed-height-m delete-bin"
            :src="$anm22.icons.getWorldIcon('deleteBin')"
            @click="openDeleteLinkDialog(i)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    links: Array,
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deleteLinkDialog: false,
      currentIndex: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      offline: state => state.offline.isOffline
    })
  },
  methods: {
    imgByLink(link) {
      let image = this.$anm22.icons.getWorldIcon("link");
      //Se non è presente l'http allora è un'icona del nostro sistema
      if (-1 == link.img.indexOf("http")) {
       let imageByLink = this.$anm22.icons.getWorldIcon(link.img);
        if (imageByLink) {
          image = imageByLink;
        }
        //Altrimenti un url ad un immagine (solo online)
      } else if (!this.offline && -1 != link.img.indexOf("http")) {
        image = link.img;
      }
      return image;
    },
    openDeleteLinkDialog(i) {
      this.currentIndex = i;
      this.deleteLinkDialog = true;
    },
    deleteLink(i) {
      this.$emit("removeLink", i);
      this.deleteLinkDialog = false;
    }
  },
  created() {},
  components: {}
};
</script>

<style lang="scss" scoped>
.links .icons {
  align-items: center;
  font-size: 0;
  padding: 5px 10px 0 0;
  flex-wrap: nowrap;
}
.links-img {
  padding: 5px;
  height: 100%;
  width: 40px;
  object-fit: contain;
}
.icon-div {
  border-radius: 30px;
  width: 60px;
  height: 60px;
  background-color: #ddd;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 10px;
  margin: 5px 10px;
  cursor: pointer;

  &:hover {
    background-color: #ccc;
  }
}
.icon-div.small {
  width: 50px;
  height: 50px;
  padding: 5px;
}
.delete-bin {
  position: absolute;
  top: 0;
  right: 3px;
  cursor: pointer;
}
</style>

